import { Button, Stack, type Theme, Typography } from '@mui/material';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';

const RegistryHarvestReminder = ({ onRegisterHarvest }: { onRegisterHarvest: () => void }) => {
    return (
        <Stack
            alignItems='center'
            justifyContent='center'
            spacing={2}
            sx={{ backgroundColor: 'grey.100', border: 1, borderColor: 'primary.mui.stroke', borderRadius: 2, p: 2 }}
        >
            <Icon
                type='harvest'
                sx={{
                    width: 36,
                    height: 36,
                    '& svg *': {
                        fill: (t: Theme) => `${t.palette.primary.main} !important`,
                        fillOpacity: '1 !important',
                    },
                }}
            />
            <Stack alignItems='center' spacing={1} sx={{ px: 3, textAlign: 'center' }}>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {_('Resultados de cosecha')}
                </Typography>
                <Typography variant='body2' color='primary'>
                    {_(
                        'Registrá los datos de la cosecha del lote para obtener el reporte de campaña con los resultados.'
                    )}
                </Typography>
            </Stack>
            <Button variant='contained' color='primary' onClick={onRegisterHarvest}>
                {_('Registrar cosecha')}
            </Button>
        </Stack>
    );
};

export default RegistryHarvestReminder;
